function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".password-encryption_svg__i{fill:none;stroke:#2196f3;stroke-linecap:round;stroke-width:3px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-104 -25)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M112.739 93.838a22.994 22.994 0 010-32.525l27.574-27.574a23 23 0 1132.527 32.525l-27.576 27.574a22.994 22.994 0 01-32.525 0z",
  fill: "#2196f3",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  width: 57,
  height: 49,
  rx: 3,
  transform: "translate(113 35)",
  strokeWidth: 2,
  stroke: "#1d1f2c",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 9,
  rx: 1,
  transform: "translate(123 67)",
  fill: "none",
  strokeWidth: 2,
  stroke: "#1d1f2c"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 5)",
  stroke: "#2196f3",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 14,
  rx: 4,
  transform: "translate(137 42)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(134 47)",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 10,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 12,
  height: 8,
  rx: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M141 52.734V51",
  strokeLinecap: "round",
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M113 44.533h15.49l4.891-4.891h36.328",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "none",
  strokeWidth: 2,
  stroke: "#1d1f2c"
}), /*#__PURE__*/React.createElement("path", {
  className: "password-encryption_svg__i",
  d: "M139 71.554v-.05M144 71.554v-.05M149 71.554v-.05M154 71.554v-.05M129 71.554v-.05M134 71.554v-.05"
}));

var SvgPasswordEncryption = function SvgPasswordEncryption(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NyIgaGVpZ2h0PSI3NyIgdmlld0JveD0iMCAwIDc3IDc3Ij48ZGVmcz48c3R5bGU+LmEsLmMsLmUsLmZ7ZmlsbDojZmZmO30uYXtvcGFjaXR5OjA7fS5ie2ZpbGw6IzIxOTZmMztvcGFjaXR5OjAuMjt9LmMsLmQsLmh7c3Ryb2tlOiMxZDFmMmM7fS5jLC5kLC5lLC5mLC5nLC5oe3N0cm9rZS13aWR0aDoycHg7fS5kLC5nLC5oLC5pLC5re2ZpbGw6bm9uZTt9LmUsLmYsLmcsLml7c3Ryb2tlOiMyMTk2ZjM7fS5mLC5nLC5oLC5pe3N0cm9rZS1saW5lY2FwOnJvdW5kO30uZiwuaHtzdHJva2UtbGluZWpvaW46cm91bmQ7fS5pe3N0cm9rZS13aWR0aDozcHg7fS5qe3N0cm9rZTpub25lO308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTA0IC0yNSkiPjxyZWN0IGNsYXNzPSJhIiB3aWR0aD0iNzciIGhlaWdodD0iNzciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwNCAyNSkiLz48cGF0aCBjbGFzcz0iYiIgZD0iTTE4MzM2LjI2NiwyMjk4Mi4zNjVhMjIuOTk0LDIyLjk5NCwwLDAsMSwwLTMyLjUyNWwyNy41NzQtMjcuNTc0YTIzLDIzLDAsMSwxLDMyLjUyNywzMi41MjVsLTI3LjU3NiwyNy41NzRhMjIuOTk0LDIyLjk5NCwwLDAsMS0zMi41MjUsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xODIyMy41MjcgLTIyODg4LjUyNykiLz48cmVjdCBjbGFzcz0iYyIgd2lkdGg9IjU3IiBoZWlnaHQ9IjQ5IiByeD0iMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEzIDM1KSIvPjxyZWN0IGNsYXNzPSJkIiB3aWR0aD0iMzciIGhlaWdodD0iOSIgcng9IjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMyA2NykiLz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDUpIj48cmVjdCBjbGFzcz0iZSIgd2lkdGg9IjgiIGhlaWdodD0iMTQiIHJ4PSI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzcgNDIpIi8+PGcgY2xhc3M9ImYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNCA0NykiPjxyZWN0IGNsYXNzPSJqIiB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIHJ4PSIyIi8+PHJlY3QgY2xhc3M9ImsiIHg9IjEiIHk9IjEiIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiByeD0iMSIvPjwvZz48cGF0aCBjbGFzcz0iZyIgZD0iTTE0MS41LDYxLjk4VjYwLjI0NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuNSAtOS4yNDYpIi8+PC9nPjxwYXRoIGNsYXNzPSJoIiBkPSJNMTEzLDQzLjUzM2gxNS40OWw0Ljg5MS00Ljg5MWgzNi4zMjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMSkiLz48cGF0aCBjbGFzcz0iaSIgZD0iTTE0MS41LDYwLjN2LS4wNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIuNSAxMS4yNTQpIi8+PHBhdGggY2xhc3M9ImkiIGQ9Ik0xNDEuNSw2MC4zdi0uMDUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuNSAxMS4yNTQpIi8+PHBhdGggY2xhc3M9ImkiIGQ9Ik0xNDEuNSw2MC4zdi0uMDUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuNSAxMS4yNTQpIi8+PHBhdGggY2xhc3M9ImkiIGQ9Ik0xNDEuNSw2MC4zdi0uMDUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUgMTEuMjU0KSIvPjxwYXRoIGNsYXNzPSJpIiBkPSJNMTQxLjUsNjAuM3YtLjA1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIuNSAxMS4yNTQpIi8+PHBhdGggY2xhc3M9ImkiIGQ9Ik0xNDEuNSw2MC4zdi0uMDUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03LjUgMTEuMjU0KSIvPjwvZz48L3N2Zz4=";
export { SvgPasswordEncryption as ReactComponent };